;(function() {
  'use strict'

  angular.module('app.core').component('channelRedirects', {
    controller: Controller,
    templateUrl: 'channel-redirects.html',
    bindings: {
      channel: '<',
      onSave: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onToggle = onToggle

    function onInit() {
      // the respondent app fills {rid} on Universal Link channels only
      ctrl.responseIdHint =
        ctrl.channel.type === ctrl.channel.Type.CUSTOM
          ? ' To include the Response ID, add {rid} (in lowercase) as a parameter value, e.g. ?glow_rid={rid}.'
          : ''
    }

    function onToggle() {
      ctrl.channel.redirects.enabled = !ctrl.channel.redirects.enabled
    }
  }
})()
